// ============================================================================
// i18n Loader Component
// Ensures i18n is initialized before rendering children
// ============================================================================

import { useEffect, useState } from 'react';
import { i18nReady } from '../i18n';

interface I18nLoaderProps {
  children: React.ReactNode;
}

export function I18nLoader({ children }: I18nLoaderProps) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Wait for i18n to be ready using the promise
    i18nReady.then(() => {
      setIsReady(true);
    }).catch((err) => {
      console.error('i18n initialization failed:', err);
      setIsReady(true); // Force ready anyway
    });
  }, []);

  if (!isReady) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading translations...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
